import React from "react";
import { BrowserRouter, Route } from "react-router-dom";

// Styling
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// States
// Layout
import AlertState from "./context/alert/AlertState";
import LayoutState from "./context/layout/LayoutState";
import AuthState from "./context/auth/AuthState";

// Parameter
import MernProductState from "./context/mern_Products/ProductState";
import MernCountryState from "./context/mern_Countries/CountryState";
import ParameterState from "./context/parameters/ParameterState";

// Checkout DB - Products
import CheckoutProductsState from "./context/checkout/products/ProductState";

// Cloudinary
import CloudinaryState from "./context/cloudinary/CloudinaryState";

// Dashboard
import DashboardState from "./context/dashboard/DashboardState";

// Shopify - Order
import OrderState from "./context/orders/v1/OrdersState";

// Shopify - Campaign v2
import CampaignState from "./context/campaign/CampaignState";

// Shopify - Report v2
import ReportState from "./context/reports/ReportState";

// Shopify - Fulfillment
import FulfillmentState from "./context/fulfillment/FulfillmentState";

// Shopify - Tracking
import TrackingState from "./context/tracking/TrackingState";

// Shopify - Monitoring
import MonitoringState from "./context/monitoring/MonitoringState";

// Shopify - Discount
import DiscountState from "./context/discounts/DiscountState";

// Shopify - Domain
import DomainState from "./context/domains/DomainState";

// Shopify - Scaling Management
import ScalingState from "./context/scaling/ScalingState";

// Facebook - Profiles
import FacebookProfilesDashboardState from "./context/facebook_profiles/dashboard/DashboardState";

// Facebook - Campaign
import FacebookCampaignState from "./context/facebook_profiles/campaign/CampaignState";

// Facebook - AdSet
import FacebookAdSetState from "./context/facebook_profiles/adset/AdSetState";

// Facebook - Ad
import FacebookAdState from "./context/facebook_profiles/ad/AdState";

// Facebook - Status Log
import StatusLogState from "./context/facebook_profiles/status_log/StatusLogState";

// Paypal - Dispute
import DisputeState from "./context/paypal/disputes/DisputeState";

// Paypal - Payment
import PaymentState from "./context/paypal/payments/PaymentState";

// Setting - Stores
import StoreState from "./context/stores/StoreState";

// Setting - Product
import ProductState from "./context/products/ProductState";

// Tech - Logs
import LogsState from "./context/logs/LogsState";

// Tech - Users
import UserState from "./context/users/UserState";

// Components
import SwitchRoutes from "./SwitchRoutes";

const App = () => {
  return (
    <AlertState>
      <LayoutState>
        <AuthState>
          <MernProductState>
            <MernCountryState>
              <ParameterState>
                <CheckoutProductsState>
                  <CloudinaryState>
                    <DashboardState>
                      <OrderState>
                        <CampaignState>
                          <ReportState>
                            <FulfillmentState>
                              <TrackingState>
                                <MonitoringState>
                                  <DiscountState>
                                    <DomainState>
                                      <ScalingState>
                                        <FacebookProfilesDashboardState>
                                          <FacebookCampaignState>
                                            <FacebookAdSetState>
                                              <FacebookAdState>
                                                <DisputeState>
                                                  <PaymentState>
                                                    <StoreState>
                                                      <ProductState>
                                                        <LogsState>
                                                          <UserState>
                                                            <StatusLogState>
                                                              <BrowserRouter>
                                                                <Route
                                                                  path="/"
                                                                  component={
                                                                    SwitchRoutes
                                                                  }
                                                                />{" "}
                                                              </BrowserRouter>{" "}
                                                            </StatusLogState>{" "}
                                                          </UserState>{" "}
                                                        </LogsState>{" "}
                                                      </ProductState>{" "}
                                                    </StoreState>{" "}
                                                  </PaymentState>{" "}
                                                </DisputeState>{" "}
                                              </FacebookAdState>{" "}
                                            </FacebookAdSetState>{" "}
                                          </FacebookCampaignState>{" "}
                                        </FacebookProfilesDashboardState>{" "}
                                      </ScalingState>{" "}
                                    </DomainState>{" "}
                                  </DiscountState>{" "}
                                </MonitoringState>{" "}
                              </TrackingState>{" "}
                            </FulfillmentState>{" "}
                          </ReportState>{" "}
                        </CampaignState>{" "}
                      </OrderState>{" "}
                    </DashboardState>{" "}
                  </CloudinaryState>{" "}
                </CheckoutProductsState>{" "}
              </ParameterState>{" "}
            </MernCountryState>{" "}
          </MernProductState>{" "}
        </AuthState>{" "}
      </LayoutState>{" "}
    </AlertState>
  );
};

export default App;
